import React, { useState } from "react";
import "leaflet/dist/leaflet.css";
import { LivePal, GearPal } from "../types/Pal";
import L from "leaflet";
import LoadingScreen from "./LoadingScreen";
import Filters from "./Filters";
import MapWrapper from "./MapWrapper";
import { useWelcome } from "./providers/WelcomeProvider";

// Fix per l'icona di default di Leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "/marker-icon-2x.png",
  iconUrl: "/marker-icon.png",
  shadowUrl: "/marker-shadow.png",
});

interface ItalyMapProps {
  livePals: LivePal[];
  gearPals: GearPal[];
  onPalUpdate: () => void;
}

const ItalyMap: React.FC<ItalyMapProps> = ({
  livePals,
  gearPals,
  onPalUpdate,
}) => {
  const [isMapReady, setIsMapReady] = useState(false);
  const { open: openWelcome } = useWelcome(); // Import useWelcome hook if not imported, verify imports.

  if (!isMapReady) {
    return <LoadingScreen onLoadingComplete={() => setIsMapReady(true)} />;
  }

  const allPals = [...livePals, ...gearPals];

  return (
    <>
      <div className="h-full w-full relative"
      style={{maxHeight: "100dvh"}}
      >
        <Filters palTypes={["LivePal", "GearPal"]} />

        {/* Info Button moved here */}
        <div className="absolute top-13 md:top-24 left-6 z-[1000] hidden">
          <button
            onClick={openWelcome}
            style={{ gap: "8px", height: "36px" }}
            className="header-button-mobile aspect-square bg-primary text-white rounded-full flex items-center justify-center shadow-lg hover:bg-primary-600 transition-all"
          >
            <img
              src={"/icons/info.svg"}
              alt="Info"
              className="h-[20px] object-contain"
            />
          </button>
        </div>

        <MapWrapper pals={allPals} onPalUpdate={onPalUpdate} />
      </div>
    </>
  );
};

export default React.memo(ItalyMap);
